import { render, staticRenderFns } from "./VehiclePanel.vue?vue&type=template&id=a2cdc0a8"
import script from "./VehiclePanel.vue?vue&type=script&lang=js"
export * from "./VehiclePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports